export function summariseBy(list, summaryOf, clearField, clearWithValue = "-") {
    const summary = list.groupBy(summaryOf)

    return Object.values(summary).map((list) => ({
        ...list[0],
        [clearField]: clearWithValue,
        count: list.reduce((a, c) => a + c.count, 0),
    }))
}
